// Currency helpers shared across the app.
export const CURRENCIES = [
  { code: "GBP", symbol: "£", label: "GBP – British Pound" },
  { code: "USD", symbol: "$", label: "USD – US Dollar" },
  { code: "EUR", symbol: "€", label: "EUR – Euro" },
  { code: "CAD", symbol: "CA$", label: "CAD – Canadian Dollar" },
  { code: "AUD", symbol: "A$", label: "AUD – Australian Dollar" },
  { code: "NZD", symbol: "NZ$", label: "NZD – New Zealand Dollar" },
  { code: "JPY", symbol: "¥", label: "JPY – Japanese Yen" },
  { code: "CHF", symbol: "CHF ", label: "CHF – Swiss Franc" },
  { code: "SEK", symbol: "kr ", label: "SEK – Swedish Krona" },
];

const SYMBOL_MAP = CURRENCIES.reduce((a, c) => ((a[c.code] = c.symbol), a), {});

export function currencySymbol(code) {
  const c = (code || "GBP").toUpperCase();
  return SYMBOL_MAP[c] || c + " ";
}

export function formatMoney(amount, code = "GBP") {
  const n = Number(amount) || 0;
  return `${currencySymbol(code)}${n.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}
